import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Est-ce que je dois être disponible pendant le processus?',
  a: "Non. Vous remplissez un formulaire en 10 minutes. Je m'occupe du reste.\nVous recevez votre profil complété en 3 à 5 jours. C'est tout."
}, {
  q: 'Comment se passe le paiement?',
  a: 'Virement bancaire, PayPal ou carte de crédit. Vous choisissez ce qui vous convient. Aucune surprise.'
}, {
  q: "C'est quoi le processus exactement?",
  a: "1. Vous m'écrivez sur WhatsApp\n2. Je vous envoie un formulaire (10 min)\n3. Je crée votre profil\n4. Vous révisez et approuvez\n5. On fait un appel de remise (15 min)\nSimple. Rapide. Efficace."
}, {
  q: "Est-ce que LinkedIn est important pour mon type d'entreprise?",
  a: 'Si vos clients, partenaires ou employeurs cherchent des professionnels en ligne —\noui, absolument. LinkedIn est la première plateforme de crédibilité professionnelle au monde.'
}, {
  q: 'Et si je ne suis pas satisfait?',
  a: "On révise ensemble jusqu'à ce que votre profil vous représente parfaitement.\nVotre satisfaction est ma priorité. ✦"
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-dark py-16 sm:py-24 lg:py-32 px-5 sm:px-6" data-id="element-7">
      <div className="max-w-[720px] mx-auto" data-id="element-8">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[28px] sm:text-[36px] font-bold text-brand-cream text-center mb-10 sm:mb-12 leading-tight" data-id="element-9">
          Questions fréquentes.
        </motion.h2>

        <div className="space-y-3" data-id="element-10">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} key={index} className="bg-brand-darker rounded-[8px] border-l-[3px] border-brand-gold overflow-hidden" data-id="element-11">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-5 sm:p-6 text-left focus:outline-none" data-id="element-12">
                  <span className="text-[15px] sm:text-[17px] font-bold text-brand-gold pr-3 sm:pr-4 leading-snug" data-id="element-13">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-gold shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-14" />
                </button>
                <AnimatePresence initial={false} data-id="element-15">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-16">
                      <div className="px-5 sm:px-6 pb-5 sm:pb-6 text-[14px] sm:text-[16px] text-brand-cream/85 leading-[1.7] whitespace-pre-line" data-id="element-17">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}